import React, { useEffect, useState, useRef } from "react";
import Footer from "./include/Footer";
import Header from "./include/Header";
import Sidebar from "./include/Sidebar";
import Pagination from "./include/Pagination";
import DateRangePickerComp from "./DateRangePickerComp";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useParams } from "react-router-dom";
import Loader from "./include/Loader";

const api_baseurl = process.env.REACT_APP_BASE_URL_API

function PayrateAndCommission() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setQuery] = useState("");
  const [order, setOrder] = useState("ASC");

  const tableRef = useRef(null);
  const params = useParams();
  let vendor_id  = atob(params.vendor_id);

  function parentAlert(demoData) {
    //console.warn(demoData);
    //setDateRange(demoData);
  }

  const sorting = (col)=>{

    if(order === 'ASC'){
      const sorted = data.result.sort((a,b) =>
      
         col=='pay_rate' || col=='service_commission'  || col=='product_commission'  || col=='service_commission'  || col=='service_commission'
         ?
         a[col].toLowerCase()-b[col].toLowerCase()
         :
         a[col].toLowerCase() > b[col].toLowerCase()? 1: -1
        
      );
      
     // setData(sorted)
      setOrder("DSC")
    }

    if(order==='DSC'){
      const sorted = data.result.sort((a,b)=>
      col=='pay_rate' || col=='service_commission'  || col=='product_commission'  || col=='service_commission'  || col=='service_commission'
          ?
          b[col].toLowerCase() - a[col].toLowerCase()
          :
          a[col].toLowerCase() < b[col].toLowerCase()? 1: -1
       
      );
    // setData(sorted)
      setOrder("ASC")
    }
  }

  useEffect(() => {
    setLoading(true);
    fetch(
      api_baseurl+"payrate_and_commission2?vendor_id=" +
        vendor_id
    ).then((res) => {
      res.json().then((response) => {
        setData(response);
        setLoading(false);
      });
    });
  }, []);

  console.log("data: ", data);

  return (
    <fregment>
      <Header></Header>
      <Sidebar></Sidebar>

      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Pay Rate & Commission</h1>
          <div className="seprator"></div>
          <nav className="export-relative">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="javascript:;">Employee Reports</a>
              </li>
              <li className="breadcrumb-item active">Pay Rate & Commission</li>
            </ol>
            <a href={api_baseurl+"payrate_and_commission2?vendor_id="+vendor_id+"&date_range="+"&is_download=1"}> <button className="export-data" ><i className="icon-excel"></i> Export Data</button></a>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="top-form">
                    <form>
                      <div className="row">
                        {/* <div className="col date-ic">
                      <label for="selectdate">Select Date</label>
                      <DateRangePickerComp alert={parentAlert}></DateRangePickerComp>
                      <div className="calendar-ic">
                        <button><i className="icon-calendar-ic"></i></button>
                      </div>
                    </div> */}
                        <div className="col search-ic col-lg-6">
                          <label for="selectdate"></label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            onChange={(e) => setQuery(e.target.value)}
                          />
                          <div className="calendar-ic">
                            <button type="button">
                              <i className="icon-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  {/*  <!-- Table with stripped rows --> */}
                  {loading ? (
                    <Loader></Loader>
                  ) : (
                    <div className="table-responsive orderid-select">
                      <table
                        class="table table-striped table-bordered"
                        rel="tableRef"
                      >
                        <thead>
                          <tr>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("status")}
                              >
                                Status
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("firstname")}
                              >
                                First Name
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("lastname")}
                              >
                                Last Name
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("type")}
                              >
                                Type
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("position")}
                              >
                                Position
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("pay_rate")}
                              >
                                Pay Rate
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                              >
                                Service
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("service_commission")}
                              >
                                Service Commission
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("product_commission")}
                              >
                                Product Commission
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.result &&
                            data.result
                              .filter(
                                (item) =>
                                  item.status
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.firstname
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.lastname
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.type
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.position
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.pay_rate
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  /* item.service_product?.toLowerCase().includes(searchQuery.toLowerCase()) || */
                                  item.service_commission
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.product_commission
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase())
                              )
                              .map((item,index) => (
                                <tr id={item.stylist_id} key={item.stylist_id}>
                                  <td>{item.status}</td>
                                  <td>{item.firstname}</td>
                                  <td>{item.lastname}</td>
                                  <td>{item.type}</td>
                                  <td>{item.position}</td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.pay_rate).toFixed(2)}
                                  </td>
                                  <td>
                                    
                                      <td>{item.service_product.split('#').map((val)=>(<tr><td style={{ textAlign: "left" }}>{val}</td></tr>))}</td>
                                    
                                    
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                  <td style={{ textAlign: "right" }}>{item.service_product_commission.split('#').map((val)=>(<tr><td style={{ textAlign: "right" }}>{val}</td></tr>))}</td>
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                  {item.commission_type=='Amount'?'$':''}
                                {item.product_commission}
                                {item.commission_type=='Percentage'?'%':''}
                                 
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {/* <!-- End Table with stripped rows --> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer></Footer>
    </fregment>
  );
}

export default PayrateAndCommission;
